//context/PermissionConstants.js

//----------------APP------------------------//
//GENERIC
export const MIN_RANK = 500000;
export const ACC_SUPER_POWER = 121;
export const DEACTIVATED_ACCOUNT = 100000;
// Identity only: Vet access is an explicit route/API allowlist, never rank based.
export const VET_ROLE_ID = 1746;
export const GET_HORSE = 50000;
export const LEARNER = 20
export const CREATE_ACCOUNT = 5


//ACCOUNTS
export const VIEW_COSTS = 1;
export const INSPECT_COSTS = VIEW_COSTS;

//WORKFLOW
export const VIEW_INV = 500;
export const VIEW_EVENTS = 500;
export const UPLOAD_MEDIA = 5000;
export const VIEW_FARM = 500;

//WORK
export const TIMESHEETS = 50;
export const VIEW_TIMESHEETS = 5;
export const ADVANCED_SETTINGS = 5;

//EMAILS (Management Email Center) -- managers and up
export const SEND_EMAILS = 15;

//SALES
export const SALES_OWNER = 5000;
export const SALES_WORKER = 50;

//OVERVIEW
export const VIEW_CLIENT = 500
export const VIEW_SYNDICATE = 5
export const VIEW_VICES = 5
export const DEL_VICES = 5
export const EDIT_NOTES = 50
export const VIEW_NOTES = 500


//HORSE
export const ADD_HORSE = 50;
export const DEL_HORSE = 50;
export const UPDATE_HORSE = 5;


//----------------TREATMENTS----------------//
export const ADD_MED = 50;
export const EDIT_MED = 50;
export const COMP_MED = 50;

export const DEL_MED = 5;

export const VIEW_MED = 5000;
export const VIEW_DRUGS = 50;
export const VIEW_APPLICATIONS = 500;

//PAGE RENDERS
export const VIEW_MEDSTOCK = 5; 

//----------------APPOINTMENTS----------------//
//GENERAL API CALLS
export const GET_APPT = 50000;

export const ADD_APPT = 50;
export const COMP_APPT = 50;
export const EDIT_APPT = 15;

export const DEL_APPT = 5;

//TABLE RENDERS
export const VIEW_APPT_NOTES = 500;

//PAGE RENDERS
export const VIEW_APPT = 500; 

//----------------MOVEMENTS----------------//
//GENERAL API CALLS
export const GET_MOVE = 50000;
export const GET_MOVE_I = 500;

export const ADD_MOVE = 50;
export const COMP_MOVE = 50;
export const EDIT_MOVE = 15;
export const GET_FEES = 50;
export const EDIT_FEES = 15;


export const DEL_MOVE = 5;

//PAGE RENDERS
export const VIEW_MOVE = 500; 

//----------------FARM WORK----------------//
export const COMP_WORK = 50; 
export const VIEW_WORK = 500; 
export const DEL_WORK = 5; 

//----------------EVENTS---------------//
export const DEL_EVENT = 5; 
export const COMP_EVENT = 50; 
export const VIEW_EVENT = 500; 

//----------------MEDIA---------------//
export const DEL_MEDIA = 5;
export const VIEW_MEDIA = 500000;
export const MED_MEDIA = 15;
export const ADD_MEDIA = 5000;
// Re-assigning an existing media item's category (Profile Update / Update / General)
// is a staff action: owners may upload and set a category at upload time, but they
// cannot change it afterwards from the media control panel.
export const EDIT_MEDIA = 50;

//----------------PROGRAMS (Breeding/Rehab/Training)---------------//
export const VIEW_PROGRAMS = 500;
export const COMP_PROGRAMS = 50;
export const DEL_PROGRAMS = 5;

//----------------MAP/FEED---------------//
export const EDIT_MAP = 5;
export const EDIT_FEED = 5;
export const VIEW_FEED = 500;
export const VIEW_MAP = 500;
